import GroupRepository from '@/repositories/GroupRepository'
import SnapsnapGateway from '@/gateways/SnapsnapGateway'
import { IGroupSetting } from '@/types/domain/group'

export interface IFetchGroupSettingUseCaseParams {
  groupRepository: GroupRepository
  snapsnapGateway: SnapsnapGateway
}

export default class FetchGroupSettingUseCase implements BaseUseCase {
  groupRepository: GroupRepository
  snapsnapGateway: SnapsnapGateway

  constructor({ groupRepository, snapsnapGateway }: IFetchGroupSettingUseCaseParams) {
    this.groupRepository = groupRepository
    this.snapsnapGateway = snapsnapGateway
  }

  async execute(groupId: number): Promise<IGroupSetting> {
    try {
      const setting = await this.snapsnapGateway.Group.getGroupSetting(groupId)
      this.groupRepository.saveGroupSetting({ groupId, setting })
      return setting
    } catch (error) {
      throw error
    }
  }
}
